import { useQuery } from "@tanstack/react-query";
import { useProductOfferStore } from "@/sales-tools";
import { getProductOffer } from "@/sales-tools/home-product/api/getProductOffer";
import { EligibilityStatus, SaleProgress } from "@/sales-tools/home-product/types";
import { usePartner, useSessionId } from "@/sdk";

export const useProductOfferPolling = () => {
    const sessionId = useSessionId();
    const primaryProducts = useProductOfferStore((state) => state.getPrimaryProducts(sessionId));
    const updateProduct = useProductOfferStore((state) => state.updateProduct);
    const primaryProduct = primaryProducts.at(0);
    const partner = usePartner();

    const isEnabled =
        !!primaryProduct &&
        primaryProduct.status === EligibilityStatus.Eligible &&
        primaryProduct.saleProgress === SaleProgress.InProgress;
    const { data, isLoading, isError } = useQuery({
        queryKey: [`sales-product-offer`, primaryProduct?.id, partner, primaryProduct?.salesProvider],
        queryFn: async () =>
            primaryProduct ? getProductOffer(primaryProduct.id, partner, primaryProduct.salesProvider) : undefined,
        refetchInterval: (isEnabled) => (isEnabled ? 15000 : false),
        enabled: isEnabled && partner === "mcafee",
    });
    if (!isLoading && !isError && !!data && primaryProduct && isEnabled) {
        if (
            primaryProduct.id === data.productOfferId &&
            (data.enrollmentStatus === "SUCCESS" || data.enrollmentStatus === "FAILURE")
        ) {
            updateProduct(sessionId, data.productOfferId, {
                saleProgress: data.enrollmentStatus.toString() as SaleProgress,
            });
        }
    }
};
